(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steep-home-editorial"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-steep-review-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-steep-review-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-steep-review-dot]'));
    const previous = carousel.querySelector('[data-steep-review-previous]');
    const next = carousel.querySelector('[data-steep-review-next]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    let timer;

    const background = carousel.closest('.steep-home-proof').querySelector('[data-steep-review-background] img');
    const photos = [background?.src, 'https://cdn.shopify.com/s/files/1/0721/7381/3959/files/DSC00323.jpg?width=1600', 'https://cdn.shopify.com/s/files/1/0721/7381/3959/files/DSCF4028.jpg?width=1600', background?.parentElement.dataset.story, background?.parentElement.dataset.wholesale];
    const show = (index) => {
      current = (index + slides.length) % slides.length;
      if(background && photos[current]) { background.removeAttribute('srcset'); background.src=photos[current]; background.alt='Steep outdoors'; }
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (!reduceMotion.matches && !document.hidden && !carousel.classList.contains('steep-touch-active') && !carousel.contains(document.activeElement) && !slides[current].hasAttribute('data-steep-review-expanded')) timer = window.setInterval(() => show(current + 1), 8000);
    };

    previous?.addEventListener('click', () => { show(current - 1); start(); });
    next?.addEventListener('click', () => { show(current + 1); start(); });
    dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); start(); }));
    reduceMotion.addEventListener('change', start);
    document.addEventListener('visibilitychange', start);
    carousel.addEventListener('steep:review-expansion', start);
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('steep:touch-effect', (event) => event.detail.active ? stop() : start());
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', (event) => {
      if (!carousel.contains(event.relatedTarget)) start();
    });
    show(0);
    start();
  });

  document.addEventListener('toggle', (event) => {
    const opened = event.target;
    if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
    const faqSection = opened.closest('[id*="__section_kNPmyK"]');
    if (!faqSection) return;
    faqSection.querySelectorAll('details[open]').forEach((details) => {
      if (details !== opened) details.removeAttribute('open');
    });
  }, true);

  } catch(e) { console.error(e); }
})();
})();
